export var PillVariant;
(function (PillVariant) {
    PillVariant["primary"] = "primary";
    PillVariant["secondary"] = "secondary";
})(PillVariant || (PillVariant = {}));
//# sourceMappingURL=index.types.js.map